import { render, staticRenderFns } from "./dataStatistic.vue?vue&type=template&id=529a1cce&scoped=true&"
import script from "./dataStatistic.vue?vue&type=script&lang=js&"
export * from "./dataStatistic.vue?vue&type=script&lang=js&"
import style0 from "./dataStatistic.vue?vue&type=style&index=0&id=529a1cce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a1cce",
  null
  
)

export default component.exports